import { render, staticRenderFns } from "./parCommercial.vue?vue&type=template&id=0ac39c22&"
import script from "./parCommercial.vue?vue&type=script&lang=js&"
export * from "./parCommercial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports